export default ($) => {
    let mediaElements = document.querySelectorAll('audio'),
        total = mediaElements.length;

    for (let i = 0; i < total; i++) {
        new MediaElementPlayer(mediaElements[i], {
            shimScriptAccess: 'always',
            iconSprite: '/wp-content/themes/selune/inc/public/images/mejs-controls.svg',
            success: function () {
                var target = document.body.querySelectorAll('.player'),
                    targetTotal = target.length;

                for (let j = 0; j < targetTotal; j++) {
                    target[j].style.visibility = 'visible';
                }
            }
        });
    }
}